export default "/_next/static/images/d7724172f352c78edb6a97938d49e824.jpg";